import type { QueryClientConfig } from '@tanstack/vue-query'

import { QueryClient } from '@tanstack/vue-query'

import { GC_TIMES, STALE_TIMES } from './constants'

export const createInertiaQueryClient = (overrides?: QueryClientConfig): QueryClient => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: STALE_TIMES.DEFAULT,
        gcTime: GC_TIMES.DEFAULT,
        refetchOnWindowFocus: false,
        retry: 1,
        ...overrides?.defaultOptions?.queries
      }
    }
  })
}
